// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splitPane_hICbx .Resizer.vertical {
    border-left: 10px solid rgba( 0, 0, 255, 0.5);
    border-right: 10px solid rgba(0, 0, 255, 0.5);
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/SplitPane.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,6CAA6C;AACjD","sourcesContent":[".splitPane :global( .Resizer.vertical ) {\n    border-left: 10px solid rgba( 0, 0, 255, 0.5);\n    border-right: 10px solid rgba(0, 0, 255, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"splitPane": `splitPane_hICbx`
};
export default ___CSS_LOADER_EXPORT___;
